import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const fortifiedHome: TaskDefinition = {
  taskName: onboardingTasks.ProvideProofOfFortifiedHome,
  config: {
    staffDisplayName: 'Proof of Fortified Home certification',
    appcuesModalId: 'a96c262f-26bf-489f-9ab3-2571cb7b7374',
    reviewTeam: reviewTeams.uwOps,
    daysAllowed: 15,
    enabled: true,
    account: {
      toastMessage: 'Your proof of Fortified Home certification documents have been submitted for review.',
      content: ({ affectedPolicies, daysAllowed }) => ({
        title: 'Proof of Fortified Home certification',
        incompleteSubtitle: 'Provide proof of your Fortified Home certification to keep your discount.',
        completedSubtitle: `You have successfully submitted for review the Fortified Home certification documents for ${affectedPolicies}.`,
        actionLabel: 'Upload proof',
        modalTitle: 'Upload your proof of Fortified Home certification',
        contentSections: [
          {
            title: 'What documents are accepted?',
            body: 'Fortified Home certification or other official documentation showing your home meets FORTIFIED standards'
          },
          {
            title: 'When do I need to submit these documents?',
            body: `You have ${daysAllowed} days from your policy effective date to turn in the verification listed above before the discount is removed.`
          }
        ]
      })
    }
  }
};
